<template>
  <vc-share-a :href="href" :style="{ textDecoration: 'none' }">
    {{ title }}
  </vc-share-a>
</template>

<script>
export default {
  name: "vc-share-a-link",
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    href: {
      type: String,
      default: ""
    }
  }
};
</script>
